"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _voyageRate = require("@/api/vessel/voyageRate");
var _date = require("@/utils/date");
var _validate = require("@/utils/validate");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'vesselMovement',
  data: function data() {
    return {
      loading: null,
      voyageRateForm: {
        vesselCode: '',
        sp: '',
        dateFrom: '',
        dateTo: ''
      },
      currentDate: new Date(),
      movementInfo: {
        vesselName: undefined,
        voyageNo: undefined,
        portName: undefined,
        terminalCode: undefined,
        eta: undefined,
        ccta: undefined,
        etb: undefined,
        cctb: undefined,
        etd: undefined,
        cctd: undefined,
        rate: undefined,
        remark: undefined,
        updatedDtmLoc: undefined
      },
      currentInfo: {
        eta: '',
        ata: undefined,
        etb: '',
        etd: undefined
      },
      isResult: false,
      rules: {
        vesselCode: [{
          required: true,
          message: this.$t('validate.vesselName'),
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    dateFormat: _date.dateFormat,
    validateNull: _validate.validateNull,
    vesselChange: function vesselChange(value, selectedRows) {
      this.voyageRateForm.vesselCode = selectedRows.vesselCode;
    },
    getShortTime: function getShortTime(date) {
      if (this.validateNull(date)) {
        return '';
      } else {
        var time = new Date(date);
        var month = time.getMonth() + 1;
        var day = time.getDate();
        if (month < 10) {
          month = '0' + month;
        }
        if (day < 10) {
          day = '0' + day;
        }
        date = month + '-' + day;
        return date;
      }
    },
    getExactTime: function getExactTime(date) {
      if (this.validateNull(date)) {
        return '';
      } else {
        var time = new Date(date);
        var month = time.getMonth() + 1;
        var day = time.getDate();
        var hour = time.getHours();
        var minute = time.getMinutes();
        if (month < 10) {
          month = '0' + month;
        }
        if (day < 10) {
          day = '0' + day;
        }
        if (hour < 10) {
          hour = '0' + hour;
        }
        if (minute < 10) {
          minute = '0' + minute;
        }
        date = month + '-' + day + ' ' + hour + ':' + minute;
        return date;
      }
    },
    /**
     * 时间戳变成时间格式
     */
    timeStampToTime: function timeStampToTime(timestamp) {
      var date = new Date(timestamp);
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '-';
      var H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + '-';
      var Min = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + '-';
      var S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + H + Min + S;
    },
    /**
     * 获取当前时间前后十四天日期时间
     */
    getTime: function getTime() {
      this.voyageRateForm.dateTo = this.timeStampToTime(this.currentDate.getTime() + 14 * 60 * 60 * 24 * 1000);
      this.voyageRateForm.dateFrom = this.timeStampToTime(this.currentDate.getTime() - 14 * 60 * 60 * 24 * 1000);
    },
    Date: function Date(day) {
      this.currentDate.setDate(this.currentDate.getDate() + day * 28);
    },
    lastMonth: function lastMonth() {
      this.Date(-1);
      this.toSearch();
    },
    nextMonth: function nextMonth() {
      this.Date(1);
      this.toSearch();
    },
    weekFormatter: function weekFormatter(str) {
      var weeki = new Date(str).getDay();
      switch (weeki) {
        case 0:
          return 'Sun';
        case 1:
          return 'Mon';
        case 2:
          return 'Tue';
        case 3:
          return 'Wed';
        case 4:
          return 'Thur';
        case 5:
          return 'Fri';
        case 6:
          return 'Sat';
      }
    },
    /**
     * 重新搜索时回到当前月份
     */
    search: function search() {
      this.currentDate = new Date();
      this.toSearch();
    },
    toSearch: function toSearch() {
      var _this = this;
      this.getTime();
      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          _this.loading = (0, _utils.load)();
          (0, _voyageRate.getSmiRateList)(_this.voyageRateForm).then(function (response) {
            _this.movementInfo = response.data.result2;
            _this.currentInfo = response.data.result1;
            _this.isResult = true;
          }).finally(function () {
            _this.loading.close();
          });
        }
      });
    },
    init: function init() {
      if (!this.validateNull(this.$route.query)) {
        this.getTime();
        this.voyageRateForm.vesselCode = this.$route.query.vesselCode;
        this.voyageRateForm.vesselName = this.$route.query.vesselName;
        this.search();
      }
      if (!this.validateNull(this.$route.params)) {
        this.getTime();
        this.voyageRateForm.vesselCode = this.$route.params.vesselCode;
        this.voyageRateForm.vesselName = this.$route.params.vesselName;
        this.search();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
};